import { render, staticRenderFns } from "./TableRiskAppraisal589.vue?vue&type=template&id=208517de&scoped=true"
import script from "./TableRiskAppraisal589.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal589.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal589.vue?vue&type=style&index=0&id=208517de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208517de",
  null
  
)

export default component.exports